import { useCallback, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { OrderContext } from "../components/providers/OrderProvider";
import Footer from "../components/Footer";
import { discountConfig } from "../config/discounts";

const ColoringType = ({ step }) => {
  const { order, setOrder, setUseMaxSize, modifyBasketItem, addMultipleItemsToBasket, setOpenShoppingCart } = useContext(OrderContext);

  const navigate = useNavigate();
  const [dealProducts, setDealProducts] = useState({ mask: null, shampoo: null, color: null });
  const [dealProductsLoading, setDealProductsLoading] = useState(true);

  const onLogoClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onColoringTypeContainerClick = useCallback(() => {
    setUseMaxSize(false);
    localStorage.setItem(
      "order",
      JSON.stringify({
        ...order,
        type: "regrowth",
        status: "filling",
      })
    );

    setOrder((order) => ({
      ...order,
      type: "regrowth",
      status: "filling",
    }));

    navigate("/colors");
  }, [navigate]);

  const onColoringTypeContainer1Click = useCallback(() => {
    setUseMaxSize(true);
    localStorage.setItem(
      "order",
      JSON.stringify({
        ...order,
        type: "lengths",
        status: "filling",
      })
    );

    setOrder((order) => ({
      ...order,
      type: "lengths",
      status: "filling",
    }));

    navigate("/colors");
  }, [navigate]);

  // Fetch mask, shampoo, and color products for deals
  useEffect(() => {
    var Airtable = require("airtable");
    var base = new Airtable({
      apiKey: process.env.REACT_APP_AIRTABLE_SECRET_API_TOKEN_READ,
    }).base(process.env.REACT_APP_AIRTABLE_BASE_ID);

    const products = { mask: null, shampoo: null, color: null };
    let productsLoaded = 0;
    const totalQueries = 3;

    const checkComplete = () => {
      productsLoaded++;
      if (productsLoaded === totalQueries) {
        setDealProducts(products);
        setDealProductsLoading(false);
      }
    };

    // Fetch masks
    base("Produkty")
      .select({
        maxRecords: 100,
        filterByFormula: "{Kategorie}='Masky'",
      })
      .eachPage(
        function page(records, fetchNextPage) {
          records.forEach(function (record) {
            const sizeInMl = record.get("Velikost (ml)");
            // Handle both number and string comparisons
            const sizeMatch = sizeInMl === 250 || sizeInMl === "250" || String(sizeInMl).trim() === "250";
            if (sizeMatch && !products.mask) {
              products.mask = {
                id: record.id,
                name: record.get("Název"),
                price: record.get("Cena"),
                productType: "Masky",
                sizes: sizeInMl ? [{
                  value: sizeInMl,
                  price_multiplicator: 1,
                  price: record.get("Cena"),
                }] : [],
                slug: record.get("Slug"),
              };
            }
          });
          fetchNextPage();
        },
        function done(err) {
          if (err) console.error("Error fetching masks:", err);
          checkComplete();
        }
      );

    // Fetch shampoos
    base("Produkty")
      .select({
        maxRecords: 100,
        filterByFormula: "{Kategorie}='Šampony'",
      })
      .eachPage(
        function page(records, fetchNextPage) {
          records.forEach(function (record) {
            const sizeInMl = record.get("Velikost (ml)");
            // Handle both number and string comparisons
            const sizeMatch = sizeInMl === 250 || sizeInMl === "250" || String(sizeInMl).trim() === "250";
            if (sizeMatch && !products.shampoo) {
              products.shampoo = {
                id: record.id,
                name: record.get("Název"),
                price: record.get("Cena"),
                productType: "Šampony",
                sizes: sizeInMl ? [{
                  value: sizeInMl,
                  price_multiplicator: 1,
                  price: record.get("Cena"),
                }] : [],
                slug: record.get("Slug"),
              };
            }
          });
          fetchNextPage();
        },
        function done(err) {
          if (err) console.error("Error fetching shampoos:", err);
          checkComplete();
        }
      );

    // Fetch a sample color (60ml) for display
    base("Produkty")
      .select({
        maxRecords: 100,
        filterByFormula: "OR({Kategorie}='Krycí barvy', {Kategorie}='Odstíny')",
      })
      .eachPage(
        function page(records, fetchNextPage) {
          records.forEach(function (record) {
            const sizeInMl = record.get("Velikost (ml)");
            // Get first 60ml color - handle both number and string
            const sizeMatch60 = sizeInMl === 60 || sizeInMl === "60" || String(sizeInMl).trim() === "60";
            if (sizeMatch60 && !products.color) {
              products.color = {
                id: record.id,
                name: record.get("Název"),
                price: record.get("Cena"),
                productType: record.get("Kategorie"),
                sizes: sizeInMl ? [{
                  value: sizeInMl,
                  price_multiplicator: 1,
                  price: record.get("Cena"),
                }] : [],
                slug: record.get("Slug"),
              };
            }
          });
          fetchNextPage();
        },
        function done(err) {
          if (err) console.error("Error fetching colors:", err);
          checkComplete();
        }
      );
  }, []);

  const handleDeal22 = useCallback((e) => {
    e.stopPropagation();
    if (!dealProducts.mask || !dealProducts.shampoo) {
      console.error("Products not loaded yet", dealProducts);
      return;
    }
    
    const maskSize = dealProducts.mask.sizes?.[0]?.value || "250";
    const shampooSize = dealProducts.shampoo.sizes?.[0]?.value || "250";
    
    // Set type and status for deal orders
    const updatedOrder = {
      ...order,
      type: "regrowth",
      status: "filling",
    };
    localStorage.setItem("order", JSON.stringify(updatedOrder));
    setOrder(updatedOrder);
    
    // Add both items in a single batch update
    addMultipleItemsToBasket([
      {
        id: dealProducts.mask.id,
        name: dealProducts.mask.name,
        productType: dealProducts.mask.productType,
        price: dealProducts.mask.price,
        image: "/maska.png",
        units: 2,
        selectedSize: String(maskSize),
        sizes: dealProducts.mask.sizes,
        slug: dealProducts.mask.slug,
      },
      {
        id: dealProducts.shampoo.id,
        name: dealProducts.shampoo.name,
        productType: dealProducts.shampoo.productType,
        price: dealProducts.shampoo.price,
        image: "/sampon.png",
        units: 2,
        selectedSize: String(shampooSize),
        sizes: dealProducts.shampoo.sizes,
        slug: dealProducts.shampoo.slug,
      },
    ]);
    setOpenShoppingCart(true);
  }, [dealProducts, addMultipleItemsToBasket, setOpenShoppingCart, order, setOrder]);

  const handleDeal11 = useCallback((e) => {
    e.stopPropagation();
    if (!dealProducts.mask || !dealProducts.shampoo) {
      console.error("Products not loaded yet", dealProducts);
      return;
    }
    
    const maskSize = dealProducts.mask.sizes?.[0]?.value || "250";
    const shampooSize = dealProducts.shampoo.sizes?.[0]?.value || "250";
    
    // Set type and status for deal orders
    const updatedOrder = {
      ...order,
      type: "regrowth",
      status: "filling",
    };
    localStorage.setItem("order", JSON.stringify(updatedOrder));
    setOrder(updatedOrder);
    
    // Add both items in a single batch update
    addMultipleItemsToBasket([
      {
        id: dealProducts.mask.id,
        name: dealProducts.mask.name,
        productType: dealProducts.mask.productType,
        price: dealProducts.mask.price,
        image: "/maska.png",
        units: 1,
        selectedSize: String(maskSize),
        sizes: dealProducts.mask.sizes,
        slug: dealProducts.mask.slug,
      },
      {
        id: dealProducts.shampoo.id,
        name: dealProducts.shampoo.name,
        productType: dealProducts.shampoo.productType,
        price: dealProducts.shampoo.price,
        image: "/sampon.png",
        units: 1,
        selectedSize: String(shampooSize),
        sizes: dealProducts.shampoo.sizes,
        slug: dealProducts.shampoo.slug,
      },
    ]);
    setOpenShoppingCart(true);
  }, [dealProducts, addMultipleItemsToBasket, setOpenShoppingCart, order, setOrder]);

  const handleDeal111 = useCallback((e) => {
    e.stopPropagation();
    if (!dealProducts.mask || !dealProducts.shampoo) {
      console.error("Products not loaded yet", dealProducts);
      return;
    }
    
    const maskSize = dealProducts.mask.sizes?.[0]?.value || "250";
    const shampooSize = dealProducts.shampoo.sizes?.[0]?.value || "250";
    
    // Set type and status for deal orders
    const updatedOrder = {
      ...order,
      type: "regrowth",
      status: "filling",
    };
    localStorage.setItem("order", JSON.stringify(updatedOrder));
    setOrder(updatedOrder);
    
    // Add only mask and shampoo, then redirect to color selection
    addMultipleItemsToBasket([
      {
        id: dealProducts.mask.id,
        name: dealProducts.mask.name,
        productType: dealProducts.mask.productType,
        price: dealProducts.mask.price,
        image: "/maska.png",
        units: 1,
        selectedSize: String(maskSize),
        sizes: dealProducts.mask.sizes,
        slug: dealProducts.mask.slug,
      },
      {
        id: dealProducts.shampoo.id,
        name: dealProducts.shampoo.name,
        productType: dealProducts.shampoo.productType,
        price: dealProducts.shampoo.price,
        image: "/sampon.png",
        units: 1,
        selectedSize: String(shampooSize),
        sizes: dealProducts.shampoo.sizes,
        slug: dealProducts.shampoo.slug,
      },
    ]);
    // Redirect to color selection page
    navigate("/colors");
  }, [dealProducts, addMultipleItemsToBasket, order, setOrder, navigate]);

  const handleDeal101 = useCallback((e) => {
    e.stopPropagation();
    if (!dealProducts.mask) {
      console.error("Mask product not loaded yet", dealProducts);
      return;
    }
    
    const maskSize = dealProducts.mask.sizes?.[0]?.value || "250";
    
    // Set type and status for deal orders
    const updatedOrder = {
      ...order,
      type: "regrowth",
      status: "filling",
    };
    localStorage.setItem("order", JSON.stringify(updatedOrder));
    setOrder(updatedOrder);
    
    // Add 1 mask and redirect to colors
    modifyBasketItem(
      dealProducts.mask.id,
      dealProducts.mask.name,
      dealProducts.mask.productType,
      dealProducts.mask.price,
      "/maska.png",
      1,
      String(maskSize),
      dealProducts.mask.sizes,
      dealProducts.mask.slug
    );
    navigate("/colors");
  }, [dealProducts, modifyBasketItem, navigate, order, setOrder]);

  const onMaskContainerClick = useCallback(() => {
    localStorage.setItem(
      "order",
      JSON.stringify({
        ...order,
        type: "regrowth",
        status: "filling",
      })
    );

    setOrder((order) => ({
      ...order,
      type: "regrowth",
      status: "filling",
    }));

    navigate("/masks");
  }, [navigate]);

  return (
    <div className="relative bg-color-white w-full overflow-hidden flex flex-col items-center justify-between min-h-screen">
      <div className="w-full overflow-hidden flex flex-col items-center justify-start">
        <Navbar onLogoClick={onLogoClick} step={step} />
        <main className="w-full mx-auto max-w-[77.5rem]">
        <div className="w-[calc(100%-48px)] mx-auto relative self-stretch overflow-hidden flex lg:flex-col py-[2.5rem] items-center lg:justify-start justify-center gap-x-[4rem] gap-y-[2.5rem] text-center text-[1rem] text-color-black font-graphie md:gap-[3rem] md:py-[2rem] md:px-0 md:box-border sm:gap-[3rem] sm:py-[2rem] sm:box-border">
            <section className="space-y-[2rem] sm:space-y-[1.5rem] w-full">
              <header className="w-full self-stretch flex flex-col items-center justify-start text-center text-[1.5rem] text-color-black font-ivy-mode">
                <h1 className="m-0 self-stretch relative text-[inherit] leading-[150%] font-bold font-inherit lg:text-[3rem] md:text-[1.5rem] sm:text-[1.5rem] sm:text-color-black">
                  Barvy
                </h1>
                <strong className="text-dimgray font-normal font-graphie">
                  Co budeš barvit?
                </strong>
              </header>
              <div className="w-full max-w-[40rem] my-0 mx-auto self-stretch flex flex-row sm:flex-col items-start justify-start gap-[1.5rem] hover:cursor-auto">
                <div
                  className="flex-1 rounded-3xl bg-color-white overflow-hidden flex flex-col pt-[1rem] px-[2.5rem] pb-[2.5rem] items-center justify-start gap-[1rem] cursor-pointer border-[1px] border-solid border-color-grey-200 hover:bg-color-grey-100 hover:box-border hover:cursor-pointer hover:border-[1px] hover:border-solid hover:border-color-grey-100 md:pl-[1.5rem] md:pr-[1.5rem] md:pb-[1.5rem] md:box-border md:hover:bg-color-grey-100 md:hover:box-border md:hover:border-[1px] md:hover:border-solid md:hover:border-color-grey-100 sm:pl-[1.5rem] sm:pr-[1.5rem] sm:pb-[1.5rem] sm:box-border sm:w-full"
                  onClick={onColoringTypeContainerClick}
                >
                  <div className="self-stretch flex flex-row items-center justify-center md:w-auto md:h-auto">
                    <img
                      className="relative w-[10.25rem] h-[10.25rem] md:w-[7.5rem] md:h-[7.5rem] sm:w-[6.5rem] sm:h-[6.5rem]"
                      alt="Odrosty"
                      src="/illustration.svg"
                      width="164"
                      height="164"
                    />
                  </div>
                  <div className="self-stretch flex flex-col items-center justify-start gap-[0.5rem]">
                    <div className="relative leading-[120%] font-semibold flex items-center justify-center">
                      Odrosty
                    </div>
                    <div className="relative leading-[120%] text-dimgray flex items-center justify-center">
                      220 Kč / barva
                    </div>
                  </div>
                </div>
                <div
                  className="flex-1 rounded-3xl bg-color-white overflow-hidden flex flex-col pt-[1rem] px-[2.5rem] pb-[2.5rem] items-center justify-start gap-[1rem] cursor-pointer border-[1px] border-solid border-color-grey-200 hover:bg-color-grey-100 hover:box-border hover:cursor-pointer hover:border-[1px] hover:border-solid hover:border-color-grey-100 md:pl-[1.5rem] md:pr-[1.5rem] md:pb-[1.5rem] md:box-border sm:w-full"
                  onClick={onColoringTypeContainer1Click}
                >
                  <div className="self-stretch flex flex-row items-center justify-center">
                    <img
                      className="relative w-[10.25rem] h-[10.25rem] md:w-[7.5rem] md:h-[7.5rem] sm:w-[6.5rem] sm:h-[6.5rem]"
                      alt="Celé vlasy"
                      src="/illustration1.svg"
                      width="164"
                      height="164"
                    />
                  </div>
                  <div className="self-stretch flex flex-col items-center justify-start gap-[0.5rem]">
                    <div className="relative leading-[120%] font-semibold flex items-center justify-center">
                      Celé vlasy
                    </div>
                    <div className="relative leading-[120%] text-dimgray flex items-center justify-center">
                      440 Kč / barva
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="lg:w-full lg:max-w-[40rem]">
              <hr className="w-px lg:w-full bg-color-grey-200 border-0 lg:h-px lg:left-0 h-[calc(100%-5rem)] lg:static absolute top-[2.5rem] m-0" />
            </div>
            <section className="space-y-[2rem] sm:space-y-[1.5rem] w-full">
              <header className="w-full self-stretch flex flex-col items-center justify-start text-center text-[1.5rem] text-color-black font-ivy-mode">
                <h1 className="m-0 self-stretch relative text-[inherit] leading-[150%] font-bold font-inherit lg:text-[3rem] md:text-[1.5rem] sm:text-[1.5rem] sm:text-color-black">
                  Vlasová kosmetika
                </h1>
                <strong className="text-dimgray font-normal font-graphie">
                  Perfektní péče o tvé vlasy
                </strong>
              </header>
              <div className="w-full max-w-[40rem] my-0 mx-auto self-stretch flex flex-row sm:flex-col items-start justify-start gap-[1.5rem] hover:cursor-auto">
                <div
                  className="flex-1 relative rounded-3xl bg-color-white overflow-clip flex flex-col items-center justify-start gap-[1.5rem] cursor-pointer border-[1px] border-solid border-color-grey-200 hover:bg-color-grey-100 hover:box-border hover:cursor-pointer hover:border-[1px] hover:border-solid hover:border-color-grey-100 md:box-border sm:w-full"
                  onClick={onMaskContainerClick}
                >
                  <strong className="absolute top-4 right-4 font-normal font-graphie rounded-full bg-color-green py-[0.344rem] px-[0.75rem] text-sm text-white z-20">
                    Nově i sáčky
                  </strong>
                  <div className="self-stretch flex flex-row items-center justify-center p-[0.5rem] pb-0">
                    <img
                      className="relative w-[10.25rem] h-[10.25rem] md:w-[7.5rem] md:h-[7.5rem] sm:w-[6.5rem] sm:h-[6.5rem]"
                      alt="Maska Hair@Home"
                      src="/maska.svg"
                      width="164"
                      height="164"
                    />
                  </div>
                  <div className="self-stretch flex flex-col items-center justify-start gap-[0.5rem] pb-[2.5rem] px-[2.5rem] md:pl-[1.5rem] md:pr-[1.5rem] md:pb-[1.5rem]">
                    <div className="relative leading-[120%] font-semibold flex items-center justify-center">
                      Maska Hair@Home
                    </div>
                    <div className="relative leading-[120%] text-dimgray flex items-center justify-center">
                      od 89 Kč
                    </div>
                  </div>
                </div>
                <div
                  className="flex-1 relative rounded-3xl bg-color-white overflow-clip flex flex-col items-center justify-start gap-[1.5rem] cursor-pointer border-[1px] border-solid border-color-grey-200 hover:bg-color-grey-100 hover:box-border hover:cursor-pointer hover:border-[1px] hover:border-solid hover:border-color-grey-100 md:box-border sm:w-full"
                  onClick={onMaskContainerClick}
                >
                  <strong className="absolute top-4 right-4 font-normal font-graphie rounded-full bg-color-orange py-[0.344rem] px-[0.75rem] text-sm text-white z-20">
                    Novinka
                  </strong>
                  <div className="self-stretch flex flex-row items-center justify-center p-[0.5rem] pb-0">
                    <img
                      className="relative w-[10.25rem] h-[10.25rem] md:w-[7.5rem] md:h-[7.5rem] sm:w-[6.5rem] sm:h-[6.5rem]"
                      alt="Šampon Hair@Home"
                      src="/sampon.svg"
                      width="164"
                      height="164"
                    />
                  </div>
                  <div className="self-stretch flex flex-col items-center justify-start gap-[0.5rem] pb-[2.5rem] px-[2.5rem] md:pl-[1.5rem] md:pr-[1.5rem] md:pb-[1.5rem]">
                    <div className="relative leading-[120%] font-semibold flex items-center justify-center">
                      Šampon Hair@Home
                    </div>
                    <div className="relative leading-[120%] text-dimgray flex items-center justify-center">
                      349 Kč
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          {/* Výhodné balíčky */}
  {discountConfig.deal22 || discountConfig.deal11 || discountConfig.deal111 || discountConfig.deal101 || discountConfig.maskColorDiscount || discountConfig.deal21Zdarma ? (
            <section className="space-y-[2rem] sm:space-y-[1.5rem] w-full mt-10">
              <header className="w-full self-stretch flex flex-col items-center justify-start text-center text-color-black font-ivy-mode">
                <h1 className="m-0 self-stretch relative text-[inherit] leading-[150%] font-bold font-inherit lg:text-[2rem] md:text-[1.25rem] sm:text-[1.5rem] sm:text-color-black">
                  Výhodné balíčky
                </h1>
              </header>
              <div className="w-[calc(100%-48px)] my-0 mx-auto self-stretch grid grid-cols-4 sm:grid-cols-1 gap-[1.5rem] hover:cursor-auto">
                {discountConfig.deal22 && (
                  <div className="rounded-3xl bg-color-white overflow-hidden flex flex-col p-[1.5rem] items-center justify-start gap-[1rem] border-[1px] border-solid border-color-grey-200 hover:bg-color-grey-100 hover:box-border hover:border-[1px] hover:border-solid hover:border-color-grey-100 md:box-border sm:w-full">
                    <div className="self-stretch flex flex-row items-center justify-center -space-x-3">
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Maska"
                          src="/maska.png"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                      </div>
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Maska"
                          src="/maska.png"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                      </div>
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Šampon"
                          src="/sampon.png"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                      </div>
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Šampon"
                          src="/sampon.png"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div className="self-stretch flex flex-col items-center justify-start gap-[0.5rem]">
                      <div className="relative leading-[120%] font-semibold flex items-center justify-center">
                       2× maska + 2× šampon
                      </div>
                      <div className="relative leading-[120%] text-dimgray flex items-center justify-center">
                      1&nbsp;199&nbsp;Kč
                      </div>
                    </div>
                    <div className="mt-auto w-full">
                      <button
                        onClick={handleDeal22}
                        disabled={dealProductsLoading || !dealProducts.mask || !dealProducts.shampoo}
                        className="cursor-pointer px-6 py-3 bg-color-black text-white font-graphie font-semibold rounded-full hover:bg-color-grey-800 transition-colors w-full disabled:bg-color-grey-300 disabled:text-dimgray/50 disabled:cursor-not-allowed"
                      >
                        Přidat do košíku
                      </button>
                    </div>
                  </div>
                )}
                {discountConfig.deal11 && (
                  <div className="rounded-3xl bg-color-white overflow-hidden flex flex-col p-[1.5rem] items-center justify-start gap-[1rem] border-[1px] border-solid border-color-grey-200 hover:bg-color-grey-100 hover:box-border hover:border-[1px] hover:border-solid hover:border-color-grey-100 md:box-border sm:w-full">
                    <div className="self-stretch flex flex-row items-center justify-center -space-x-3">
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Maska"
                          src="/maska.png"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                      </div>
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Šampon"
                          src="/sampon.png"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div className="self-stretch flex flex-col items-center justify-start gap-[0.5rem]">
                      <div className="relative leading-[120%] font-semibold flex items-center justify-center">
                        Šampon + maska
                      </div>
                      <div className="relative leading-[120%] text-dimgray flex items-center justify-center">
                        599&nbsp;Kč
                      </div>
                    </div>
                    <div className="mt-auto w-full">
                      <button
                        onClick={handleDeal11}
                        disabled={dealProductsLoading || !dealProducts.mask || !dealProducts.shampoo}
                        className="cursor-pointer px-6 py-3 bg-color-black text-white font-graphie font-semibold rounded-full hover:bg-color-grey-800 transition-colors w-full disabled:bg-color-grey-300 disabled:text-dimgray/50 disabled:cursor-not-allowed"
                      >
                        Přidat do košíku
                      </button>
                    </div>
                  </div>
                )}
                {discountConfig.deal111 && (
                  <div className="rounded-3xl bg-color-white overflow-hidden flex flex-col p-[1.5rem] items-center justify-start gap-[1rem] border-[1px] border-solid border-color-grey-200 hover:bg-color-grey-100 hover:box-border hover:border-[1px] hover:border-solid hover:border-color-grey-100 md:box-border sm:w-full">
                    <div className="self-stretch flex flex-row items-center justify-center -space-x-3">
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Šampon"
                          src="/sampon.png"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                      </div>
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Maska"
                          src="/maska.png"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                      </div>
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Barva"
                          src="/barva1.jpg"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div className="self-stretch flex flex-col items-center justify-start gap-[0.5rem]">
                      <div className="relative leading-[120%] font-semibold flex items-center justify-center">
                        Šampon + maska + barva
                      </div>
                      <div className="relative leading-[120%] text-dimgray flex items-center justify-center">
                        799&nbsp;Kč
                      </div>
                    </div>
                    <div className="mt-auto w-full">
                      <button
                        onClick={handleDeal111}
                        disabled={dealProductsLoading || !dealProducts.mask || !dealProducts.shampoo}
                        className="cursor-pointer px-6 py-3 bg-color-black text-white font-graphie font-semibold rounded-full hover:bg-color-grey-800 transition-colors w-full disabled:bg-color-grey-300 disabled:text-dimgray/50 disabled:cursor-not-allowed"
                      >
                        Přidat do košíku
                      </button>
                    </div>
                  </div>
                )}
                {discountConfig.deal101 && (
                  <div className="rounded-3xl bg-color-white overflow-hidden flex flex-col p-[1.5rem] items-center justify-start gap-[1rem] border-[1px] border-solid border-color-grey-200 hover:bg-color-grey-100 hover:box-border hover:border-[1px] hover:border-solid hover:border-color-grey-100 md:box-border sm:w-full">
                    <div className="self-stretch flex flex-row items-center justify-center -space-x-3">
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Maska"
                          src="/maska.png"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                      </div>
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Barva"
                          src="/barva3.jpg"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div className="self-stretch flex flex-col items-center justify-start gap-[0.5rem]">
                      <div className="relative leading-[120%] font-semibold flex items-center justify-center">
                        Maska + barva (60 ml)
                      </div>
                      <div className="relative leading-[120%] text-dimgray flex items-center justify-center">
                        549&nbsp;Kč
                      </div>
                    </div>
                    <div className="mt-auto w-full">
                      <button
                        onClick={handleDeal101}
                        disabled={dealProductsLoading || !dealProducts.mask}
                        className="cursor-pointer px-6 py-3 bg-color-black text-white font-graphie font-semibold rounded-full hover:bg-color-grey-800 transition-colors w-full disabled:bg-color-grey-300 disabled:text-dimgray/50 disabled:cursor-not-allowed"
                      >
                        Vybrat barvu
                      </button>
                    </div>
                  </div>
                )}
                {discountConfig.maskColorDiscount && (
                  <div className="rounded-3xl bg-color-white overflow-hidden flex flex-col p-[1.5rem] items-center justify-start gap-[1rem] border-[1px] border-solid border-color-grey-200 hover:bg-color-grey-100 hover:box-border hover:border-[1px] hover:border-solid hover:border-color-grey-100 md:box-border sm:w-full">
                    <div className="self-stretch flex flex-row items-center justify-center -space-x-3">
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Maska"
                          src="/maska.png"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                      </div>
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Barva"
                          src="/barva3.jpg"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div className="self-stretch flex flex-col items-center justify-start gap-[0.5rem]">
                      <div className="relative leading-[120%] font-semibold flex items-center justify-center">
                        Maska + barva (60 ml)
                      </div>
                      <div className="relative leading-[120%] text-dimgray flex items-center justify-center">
                        529&nbsp;Kč
                      </div>
                    </div>
                    <div className="mt-auto w-full">
                      <button
                        onClick={handleDeal101}
                        disabled={dealProductsLoading || !dealProducts.mask}
                        className="cursor-pointer px-6 py-3 bg-color-black text-white font-graphie font-semibold rounded-full hover:bg-color-grey-800 transition-colors w-full disabled:bg-color-grey-300 disabled:text-dimgray/50 disabled:cursor-not-allowed"
                      >
                        Vybrat barvu
                      </button>
                    </div>
                  </div>
                )}
                {discountConfig.deal21Zdarma && (
                  <div
                    className="rounded-3xl bg-color-white overflow-hidden flex flex-col p-[1.5rem] items-center justify-start gap-[1rem] border-[1px] border-solid border-color-grey-200 hover:bg-color-grey-100 hover:box-border hover:border-[1px] hover:border-solid hover:border-color-grey-100 md:box-border sm:w-full"
                    onClick={() => navigate("/colors")}
                  >
                    <div className="self-stretch flex flex-row items-center justify-center -space-x-3">
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Barva"
                          src="/barva1.jpg"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                      </div>
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Barva"
                          src="/barva2.jpg"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                      </div>
                      <div className="relative w-[2.5rem] h-[2.5rem] rounded-full overflow-hidden border-2 border-white aspect-square bg-color-grey-100">
                        <img
                          className="w-full h-full object-cover"
                          alt="Barva zdarma"
                          src="/barva3.jpg"
                          width="40"
                          height="40"
                          loading="lazy"
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                          <span className="bg-color-green text-white text-[0.6rem] font-semibold px-2 py-1 rounded-full z-10 -rotate-45">
                            zdarma
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="self-stretch flex flex-col items-center justify-start gap-[0.5rem]">
                      <div className="relative leading-[120%] font-semibold flex items-center justify-center">
                        2+1 zdarma na barvy
                      </div>
                      <div className="relative leading-[120%] text-dimgray flex items-center justify-center">
                        60 ml
                      </div>
                    </div>
                    <div className="mt-auto w-full">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate("/colors");
                        }}
                        disabled={dealProductsLoading}
                        className="cursor-pointer px-6 py-3 bg-color-black text-white font-graphie font-semibold rounded-full hover:bg-color-grey-800 transition-colors w-full disabled:bg-color-grey-300 disabled:text-dimgray/50 disabled:cursor-not-allowed"
                      >
                        Vybrat barvy
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </section>
          ) : null}

          {/* Potřebuješ poradit s odstínem? */}
          <section className="w-[calc(100%-48px)] mx-auto mb-10 mt-16">
            <div className="py-6 px-10 pr-8 bg-color-grey-100 rounded-3xl flex flex-row justify-between gap-4 sm2:flex-col sm2:items-center">
              <div className="flex flex-col gap-4 max-w-[40rem]">
                <h2 className="font-ivy-mode font-bold text-5xl leading-9 text-color-black py-0 my-0">
                  Potřebuješ poradit s odstínem?
                </h2>
                <p className="font-graphie font-normal text-base leading-6 text-color-grey-600 py-0 my-0">
                  Stáhni si{" "}
                  <a
                    href="https://hairathome.cz/#top"
                    targer="_blank"
                    className="no-underline text-color-black font-semibold transition-all hover:text-color-grey-600"
                  >
                    aplikaci Hair@Home
                  </a>{" "}
                  a využij na výběru barev funkci „Potřebuji poradit“. Bezplatně
                  ti poradím, jaká barva je pro tebe nejlepší.
                </p>
              </div>
              <div className="relative min-w-[9.375rem]">
                <img
                  src="/libor-kadernik.svg"
                  alt="Potřebuješ poradit s odstínem?"
                  className="absolute bottom-0 sm2:relative"
                />
              </div>
            </div>
          </section>
        </main>
      </div>
      <Footer />
      {/*<aside className="max-w-3xl relative self-stretch bg-color-green bg-opacity-30 rounded-3xl p-[2rem] lg:p-[1.5rem] flex flex-col gap-[0.75rem] m-[1.5rem_auto] lg:m-[1.5rem_2rem]">
        <h2 className="font-ivy-mode my-0">Akce 2+1 zdarma</h2>
        <p className="text-black my-0 opacity-75 leading-normal pr-32 lg:pr-8">
          Vlož do košíku 2 masky a barvu a získáš slevu 220 Kč, tedy lahvičku
          barvy zdarma!
        </p>
        <img
          src="/2masky-plus-barva_prazdne_bila.png"
          alt="akce 2+1 zdarma"
          width="256"
          height="254"
          className="absolute -top-4 right-4 w-32 h-32 lg:w-24 lg:h-24 object-contain"
        />
  </aside>*/}
    </div>
  );
};

export default ColoringType;
